
function Countdown () {

  const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

  let getDate = document.querySelector('.countdown__date');

  let countDown = new Date(getDate.innerText).getTime(),
  x = setInterval(function() {
    let now = new Date().getTime(),
    distance = countDown - now;

    document.getElementById('days').innerText = Math.floor(distance / (day)),
      document.getElementById('hours').innerText = Math.floor((distance % (day)) / (hour)),
      document.getElementById('minutes').innerText = Math.floor((distance % (hour)) / (minute)),
      document.getElementById('seconds').innerText = Math.floor((distance % (minute)) / second);

  }, second)

}

export default Countdown;


// WEBPACK FOOTER //
// ./src/js/app/components/Countdown.js